import { render } from "./ProfileCourseContentSubpage.vue?vue&type=template&id=f6d2bd44&scoped=true"
import script from "./ProfileCourseContentSubpage.vue?vue&type=script&lang=js"
export * from "./ProfileCourseContentSubpage.vue?vue&type=script&lang=js"

import "./ProfileCourseContentSubpage.vue?vue&type=style&index=0&id=f6d2bd44&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6d2bd44"]])

export default __exports__